import 'babel-polyfill';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import BaiduMap from 'vue-baidu-map';
// import axios from 'axios'

import './utils/message-define';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import VueEllipsis from 'vue-ellipsis-component';
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(BaiduMap, {
  ok: 'PEoA01px9ebtWx43Fcp9OWQ7v8Urx3Wx'
});
// Vue.use(VueEllipsis);
import ellipsis from '@hyjiacan/vue-ellipsis';
Vue.use(ellipsis);
import echarts from 'echarts';
import china from 'echarts/map/json/china.json';
echarts.registerMap('china', china);
Vue.prototype.$echarts = echarts;

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(VueAwesomeSwiper);

import store from './store';

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

import { VueJsonp } from 'vue-jsonp'; // 网上很多博客引用不加{}，会报错
Vue.use(VueJsonp);

Vue.config.productionTip = false;
// Vue.prototype.HOST="/api"
//设置超时时间
// axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
// axios.defaults.baseURL = 'http://10.4.69.151:18848'
// Vue.prototype.$http = axios

// 图片服务器地址
// Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'
// import Vuex from 'vuex';
// const getters = {
//   routeParams: state => state.routeParams.params
// };
// Vue.use(Vuex);
//  const store=new Vuex.Store({
//   state: {},
//   getters,
//   modules: { routeParams }
// });
// Vue.prototype.$store=store
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
